import AboutFullscreenAsset from './AboutFullscreenAsset';

export default AboutFullscreenAsset;
